import React from 'react';

export const DatePicker = () => {
  return <div>DatePicker</div>;
};
